import { Component } from '@angular/core';
import { AppConfig } from '../../../../../app/app.config';
import { PtLuxonDate } from '../../../../../models/projects/date.models';
import {
  DailyLegLoad,
  DailyLegLoadStandaloneEditor
} from '../../../../../models/daily-leg-loads/daily-leg-load.models';
import { DateService } from '../../../../../services/date/date.service';
import { NavParams, ViewController } from 'ionic-angular';
import {
  DailyLegLoadStandaloneService
} from '../../../../../services/daily-leg-loads/daily-leg-load-standalone.service';
import { cloneDeep } from 'lodash';
import { DateLostInTimeResult } from '../../../../../models/time-zones/time-zone.models';

@Component({
  selector: 'daily-leg-loads-add-standalone-reading',
  templateUrl: 'daily-leg-loads-add-standalone-reading.html'
})
export class DailyLegLoadsAddStandaloneReadingComponent {
  config = AppConfig.settings;
  dailyLogDate: PtLuxonDate;
  isWeb: boolean;
  legLoadData: DailyLegLoad[];
  standaloneEditor: DailyLegLoadStandaloneEditor;
  mask: Array<string | RegExp> = [/[0-2]/, /\d/, ':', /[0-5]/, /\d/];
  saveLoading: boolean;
  readingTimeValid: boolean;
  displayDuplicateTimeErrorMessage: boolean;
  displayDateLostInTimeErrorMessage: boolean;
  lostInTimeResult: DateLostInTimeResult;

  constructor(private dateService: DateService,
              public navParams: NavParams,
              public viewController: ViewController,
              private dailyLegLoadStandaloneService: DailyLegLoadStandaloneService,
  ) {
    this.dailyLogDate = this.navParams.get('dailyLogDate');
    this.isWeb = this.navParams.get('isWeb');
    this.legLoadData = this.navParams.get('legLoadData');
    this.standaloneEditor = new DailyLegLoadStandaloneEditor();
    this.saveLoading = false;
  }

  regexChange(inputTime: string) {
    if (inputTime.charAt(0) === '2') {
      this.mask[1] = new RegExp('[0-3]');
    } else {
      this.mask[1] = new RegExp('\\d');
    }
  }

  async closeModal(choice: boolean) {
    if (choice) {
      await this.saveStandaloneReading();
    } else {
      await this.viewController.dismiss({choice: false});
    }
  }

  async saveStandaloneReading() {
    this.displayDuplicateTimeErrorMessage = false;
    this.saveLoading = true;

    this.standaloneEditor.readingTimeOffset = this.standaloneEditor.readingTime.dateTime.offset / 60;

    const timeValid = await this.dailyLegLoadStandaloneService.validateTime(cloneDeep(this.standaloneEditor));

    if (!timeValid) {
      this.displayDuplicateTimeErrorMessage = true;
      this.saveLoading = false;
      return;
    }

    await this.dailyLegLoadStandaloneService.saveDailyLegLoadStandaloneEditor(cloneDeep(this.standaloneEditor));

    await this.viewController.dismiss({choice: true});
  }

  async readingTimeAltered() {
    this.displayDuplicateTimeErrorMessage = false;
    this.readingTimeValid = this.dateService.timeIsValid(this.standaloneEditor.readingTimeShow);

    if (!this.readingTimeValid || this.standaloneEditor.readingTimeShow === '') {
      return;
    }

    this.standaloneEditor.readingTime = await this.dateService
      .setPtLuxonDateFromUserEnteredString(this.standaloneEditor.readingTimeShow, this.dailyLogDate.dateTime, this.standaloneEditor.readingTimeOffset);
    this.standaloneEditor.readingTimeOffset = this.standaloneEditor.readingTime.dateTime.offset / 60;

    this.lostInTimeResult = cloneDeep(this.standaloneEditor.readingTime.isLostInTime);

    if (this.lostInTimeResult && this.lostInTimeResult.result) {
      this.displayDateLostInTimeErrorMessage = true;
    } else {
      this.displayDateLostInTimeErrorMessage = false;
    }
  }

  offsetSelected(offsetSelectedPtDate: PtLuxonDate) {
    this.standaloneEditor.readingTimeOffset = offsetSelectedPtDate.dateTime.offset / 60;
  }
}



// WEBPACK FOOTER //
// ./src/pages/daily-leg-loads/daily-leg-load-manage-readings/components/daily-leg-load-add-standalone-reading/daily-leg-loads-add-standalone-reading.ts